
import React, { FunctionComponent, HTMLAttributes } from "react";
import RawSvgFile from "../../resources/svg/nvon-logo.svg";

export const NvonLogo: FunctionComponent<HTMLAttributes<SVGElement>> = (
  props
) => {
  return <RawSvgFile {...props} />;
};
